module.exports = __webpack_public_path__ + "media/configurations/ZOC_P-X-11ac62f4.png";